import { type PropsWithChildren } from "react";
import {
  ItemSelectStateContext,
  type ItemSelectContextState,
} from "./item-select-context";

export function ItemSelectStateProvider(
  props: PropsWithChildren<ItemSelectContextState>,
) {
  const { children, ...value } = props;

  return (
    <ItemSelectStateContext.Provider value={value}>
      {children}
    </ItemSelectStateContext.Provider>
  );
}
